import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef } from 'react';
import StadoPayrollInfo from "./Components/StadoPayrollInfo";
import StadoPayrollFeature from "./Components/StadoPayrollFeature";
import StadoPayrollFaq from "./Components/StadoPayrollFaq";
import StadoPayrollValue from "./Components/StadoPayrollValue";
import StadoPayrollCompare from "./Components/StadoPayrollCompare";
import StadoPayrollContact from "./Components/StadoPayrollContact";
import StadoPayrollFooter from "./Components/StadoPayrollFooter";
import StadoPayrollFloating from "./Components/StadoPayrollFloating";
import StadoPayrollFloatingNav from "./Components/StadoPayrollFloatingNav";

const LandingPage = () => {
  const countersRef = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {

    const duration = 1400;

    countersRef.current.forEach((counter) => {
      if (!counter) return;

      const target = parseFloat(counter.getAttribute('data-target'));
      const isDecimal = target % 1 !== 0;
      let startTime = null;

      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const value = progress * target;

        counter.textContent = isDecimal ? value.toFixed(1) : Math.floor(value);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          counter.textContent = target;
        }
      };

      requestAnimationFrame(animate);
    });

  }, []);

  return (
    <>
      <style>{`
        .hero-section-container {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          
          background: #0c0c14;
          overflow-x: hidden;
        }

        .hero {
          min-height: 100vh;
          width: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 160px 8% 80px;
          background:
            radial-gradient(60% 40% at 15% 10%, rgba(255,61,110,.20), transparent 60%),
            radial-gradient(60% 40% at 85% 90%, rgba(255,145,77,.20), transparent 60%),
            linear-gradient(180deg,#090911,#0d0d17);
        }

        .hero-logo {
          position: absolute;
          top: 70px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 5;
        }
        .hero-logo img {
          width: 110px;
          filter: drop-shadow(0 0 25px rgba(255,80,140,.8));
        }

        .hero-grid {
          max-width: 1200px;
          width: 100%;
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: 60px;
          align-items: center;
          margin-top:40px;
        }

        .hero-left span.badge {
          display: inline-block;
          background: rgba(255,80,130,.15);
          color: #ff5a8f;
          padding: 7px 16px;
          border-radius: 999px;
          margin-bottom: 18px;
          font-size: 13px;
        }
          .hero-left > * {
            margin-bottom: 18px;
          }

          .hero-left > *:last-child {
            margin-bottom: 0;
          }
          .hero-left h1 {
            margin-top: 10px;
            margin-bottom: 16px;
          }

          .hero-left p.description {
            margin-bottom: 24px;
          }

          .hero-btns {
            margin-bottom: 32px;
          }


        .hero-left h1 {
          font-size: 20px;
          font-weight: 900;
          color: #fff;
          line-height: 1.15;
          margin:28px 0 30px;
        }
        .hero-left h1 .accent {
          background: linear-gradient(90deg,#ff3b69,#ff914d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-left p.description {
          color: #ccc;
          font-size: 16px;
          margin: 29px 0 35px;
          max-width: 520px;
        }

        .hero-btns {
          display: flex;
          align-items: center;
        }
        
        .btn-alt {
          background: linear-gradient(90deg,#ff3b69,#ff914d);
          color: white;
          padding: 14px 30px;
          border-radius: 999px;
          text-decoration: none;
          font-weight: 600;
          box-shadow: 0 12px 28px rgba(255,80,120,0.45);
          transition: .25s ease;
        }
        .btn-alt:hover {
          transform: scale(1.07);
          box-shadow: 0 16px 36px rgba(255,80,140,0.65);
          color: white;
        }
        .btn-alt-1 {
            position: relative;
            overflow: hidden;
            background: transparent;
            color: white;
            padding: 14px 30px;
            border-radius: 999px;
            text-decoration: none;
            font-weight: 600;
            border: 2px solid #ff5a7a;
            transition: 0.35s ease;
            z-index: 1;
          }

          .btn-alt-1::before {
            content: "";
            position: absolute;
            inset: 0;
            background: linear-gradient(90deg, #ff3b69, #ff914d);
            transform: scaleX(0);
            transform-origin: left;
            transition: transform 0.35s ease;
            z-index: -1;
          }

          .btn-alt-1:hover::before {
            transform: scaleX(1);
          }

          .btn-alt-1:hover {
            color: white;
            box-shadow: 0 16px 36px rgba(255, 80, 140, 0.55);
            transform: translateY(-2px);
          }

        .hero-stats {
          display: flex;
          gap: 42px;
          margin-top: 50px;
          flex-wrap: wrap;
        }
        .stat h3 {
          font-size: 32px;
          font-weight: 900;
          background: linear-gradient(90deg,#ff3b69,#ff914d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          display: flex;
          align-items: baseline;
          gap: 4px;
        }
        .stat p {
          color: #aaa;
          font-size: 13px;
          margin-top: 10px;
          text-align: left;
        }
        .count {
          background: none;
          color: inherit;
          font-size: inherit;
          font-weight: inherit;
        }

        .hero-right { perspective: 1000px; }
        .dashboard {
          width: 100%;
          max-width: 560px;
          border-radius: 10px;
          box-shadow: 0 40px 90px rgba(0,0,0,.65);
          transition: .6s cubic-bezier(.2,.8,.2,1);
        }

        @media (hover: hover) and (pointer: fine) {
          .hero-right:hover .dashboard {
            transform: translateY(-12px) rotateX(6deg) rotateY(-6deg) scale(1.03);
            box-shadow: 0 50px 120px rgba(255,80,140,.55);
          }
        }

        @media(max-width: 992px) {
          .hero-grid { grid-template-columns: 1fr; text-align: center; gap: 40px; }
          .hero-left p.description { margin-left: auto; margin-right: auto; }
          .hero-stats { justify-content: center; }
          .stat p { text-align: center; }
          .hero-btns { justify-content: center; }
        }

        @media(max-width: 600px) {
          .hero { padding: 130px 6% 60px; }

          .hero-logo { top: 100px; }

          .hero-left {
            margin-top: 70px; /* 🔥 gap between logo and badge */
          }
            .hero-left span.badge {
                  display: inline-flex;      /* inline + flexible */
                  align-items: center;
                  justify-content: center;
                  white-space: nowrap;       /* prevent breaking into 2 lines */
                  max-width: 100%;
                  font-size: 11px;           /* slightly smaller for mobile */
                  padding: 6px 12px;
                }


          .hero-left h1 { font-size: 15px; }
          .hero-left p.description { font-size: 14px; }

          .btn-alt { padding: 13px 22px; font-size: 14px; }

          .stat h3 { font-size: 26px; }
          .hero-stats { gap: 28px; margin-top: 36px; }

          .dashboard {
            opacity: 0;
            transform: scale(.85) translateY(25px);
            animation: mobileImageZoom 1s ease forwards;
            animation-delay: .3s;
            max-width: 92%;
            margin: auto;
          }

          @keyframes mobileImageZoom {
            to {
              opacity: 1;
              transform: scale(1) translateY(0);
              box-shadow: 0 45px 120px rgba(255,80,140,.55);
            }
          }

          /* 🔥 MOBILE BUTTON FIX */
          .hero-btns {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 14px;
          }

          .hero-btns a {
            width: 100%;
            max-width: 300px;
            text-align: center;
            margin: 0 !important;
          }

          .btn-playstore-black {
            margin-left: 0 !important;
            display: flex;
            justify-content: center;
          }
        }

        .btn-playstore-black {
          display: inline-flex;
          align-items: center;
          margin-left: 18px;
          height: 52px;
          background: transparent;
          border: none;
          padding: 0;
          transition: all .25s ease;
        }
        .btn-playstore-black img { height: 42px; display: block; }
        .btn-playstore-black:hover { transform: scale(1.06); }
      `}</style>

      <div className="hero-section-container">
        <section className="hero">
          <div className="hero-logo">
            <img src="/logo-dark.png" alt="Logo" />
          </div>

          <div className="hero-grid">
            <div className="hero-left">
              <span className="badge">STADO PAYROLL - SMART WORKFORCE PLATFORM</span>
              <h1>
                Stado Payroll:{' '}
                <span className="accent">The Automated HRMS, Attendance, and GPS Tracking Platform</span>
              </h1>

              <p className="description">
                Unify your workforce data. From live field tracking to instant leave approvals, Stado delivers a single dashboard to manage attendance, payroll, and performance—helping you reduce manual work, improve accuracy, and scale faster.
              </p>

              <div className="hero-btns flex gap-4">
                <button className="btn-alt" onClick={() => navigate("/book-demo")}>
                  Start Using Stado Payroll →
                </button>

                <button className="btn-alt-1" onClick={() => navigate("/auth/sign-in")}>
                  SignIn →
                </button>
              </div>

              <div className="hero-stats">
                <div className="stat">
                  <h3>
                    <span className="count" data-target="85" ref={el => countersRef.current[0] = el}>0</span>%
                  </h3>
                  <p>Automation</p>
                </div>
                <div className="stat">
                  <h3>
                    <span className="count" data-target="99.9" ref={el => countersRef.current[1] = el}>0</span>%
                  </h3>
                  <p>Accuracy</p>
                </div>
                <div className="stat">
                  <h3>
                    <span className="count" data-target="98" ref={el => countersRef.current[2] = el}>0</span>%
                  </h3>
                  <p>Customer Trust</p>
                </div>
              </div>
            </div>

            <div className="hero-right">
              <img
                className="dashboard"
                src="/Dashboard.png"
                alt="Dashboard Preview"
              />
            </div>
          </div>
        </section>
        <StadoPayrollInfo />
        <StadoPayrollFeature />
        <StadoPayrollValue />
        <StadoPayrollFaq />
        <StadoPayrollCompare />
        <StadoPayrollContact />
        <StadoPayrollFooter />
        <StadoPayrollFloating />
        <StadoPayrollFloatingNav />
      </div>
    </>
  );
};

export default LandingPage;
